import { z } from 'zod';
/**
 * Appointments — GBV-DEV-2026-001 Section 09.
 *
 * The client portal has shown a calendar of these since the beginning. This is
 * the other half: the staff-side write path, without which the client is
 * looking at a promise nobody can make.
 */
/** Longest a single appointment may run. A week-long "meeting" is a typo. */
const MAX_DURATION_MINUTES = 12 * 60;
export const appointmentCreateSchema = z
    .object({
    title: z.string().trim().min(3, 'Give this a title the client would recognise.').max(160),
    description: z.string().trim().max(2000).optional().or(z.literal('')),
    /** Optional: an appointment may exist without a lead behind it. */
    leadId: z.string().cuid().nullable().optional(),
    startsAt: z.coerce.date(),
    endsAt: z.coerce.date(),
    location: z.string().trim().max(240).optional().or(z.literal('')),
    /**
     * Book over an existing appointment in the same person's diary.
     *
     * Off by default: the overlap is almost always a mistake, and the one time
     * it is not, saying so explicitly costs a click.
     */
    allowOverlap: z.boolean().default(false),
})
    .refine((v) => v.endsAt > v.startsAt, {
    path: ['endsAt'],
    message: 'The end time has to be after the start.',
})
    .refine((v) => (v.endsAt.getTime() - v.startsAt.getTime()) / 60_000 <= MAX_DURATION_MINUTES, { path: ['endsAt'], message: 'That is longer than a day. Check the end time.' });
export const appointmentUpdateSchema = appointmentCreateSchema;
export const appointmentRangeQuery = z.object({
    from: z.coerce.date(),
    to: z.coerce.date(),
    /** Narrow to one person's diary. Absent means the whole client's. */
    ownerId: z.string().cuid().optional(),
});
export const APPOINTMENT_STATUSES = ['SCHEDULED', 'IN_PROGRESS', 'COMPLETED'];
/** Sensible default length, and the options the booking form offers. */
export const DEFAULT_APPOINTMENT_MINUTES = 30;
export const APPOINTMENT_DURATIONS = [15, 30, 45, 60, 90, 120, 180];
//# sourceMappingURL=appointment.schema.js.map